import { BaseFormBuilder } from "src/app/core/formBuilders/BaseFormBuilder";
import { PagingSearchCriteria } from "src/app/shared/model/PagingSearchCriteria";
import { UntypedFormBuilder } from "@angular/forms";
import { RepairStatus } from "./RepairStatus";
import { TripleStateBoolean } from "src/app/shared/model/TripleStateBoolean";

export interface SearchRepairsCriteria extends PagingSearchCriteria {
  claimIdentifier: string | null;
  handlingWorkshopId: number | null;
  handlingEmployeeId: number | null;
  dealerId?: number;
  repairStatusIds: number[];
  repairTypeIds: number[];
  excludedWorkshopIds: number[];
  claimOperatingCompanyIds: number[];
  repairPlaceSharingWorkshopIds?: number[];
  repairCity: string;
  paidState: number;
  text: string;
  startOfCloseDate: Date | null;
  endOfCloseDate: Date | null;
  minForecastedDate: Date | null;
  maxForecastedDate: Date | null;
}

export class SearchRepairsCriteriaFormBuilder extends BaseFormBuilder {
  static getForm(
    fb: UntypedFormBuilder,
    searchCriteria: SearchRepairsCriteria
  ) {
    return fb.group({
      claimIdentifier: [searchCriteria.claimIdentifier],
      handlingEmployeeId: [searchCriteria.handlingEmployeeId],
      handlingWorkshopId: [searchCriteria.handlingWorkshopId],
      dealerId: [searchCriteria.dealerId],
      startOfCloseDate: [this.dateValue(searchCriteria.startOfCloseDate)],
      endOfCloseDate: [this.dateValue(searchCriteria.endOfCloseDate)],
      minForecastedDate: [this.dateValue(searchCriteria.minForecastedDate)],
      maxForecastedDate: [this.dateValue(searchCriteria.maxForecastedDate)],
      repairStatusIds: [searchCriteria.repairStatusIds],
      repairTypeIds: [searchCriteria.repairTypeIds],
      repairCity: [searchCriteria.repairCity],
      excludedWorkshopIds: [searchCriteria.excludedWorkshopIds],
      claimOperatingCompanyIds: [searchCriteria.claimOperatingCompanyIds],
      repairPlaceSharingWorkshopIds: [
        searchCriteria.repairPlaceSharingWorkshopIds,
      ],
      paidState: [searchCriteria.paidState],
      text: [searchCriteria.text],
    });
  }

  static initSearchRepairsCriteria(): SearchRepairsCriteria {
    return {
      repairStatusIds: [],
      repairTypeIds: [],
      handlingEmployeeId: 0,
      paidState: TripleStateBoolean.All,
      handlingWorkshopId: 0,
      dealerId: 0,
      startOfCloseDate: null,
      endOfCloseDate: null,
      minForecastedDate: null,
      maxForecastedDate: null,
      claimIdentifier: null,
      repairCity: "",
      excludedWorkshopIds: [],
      claimOperatingCompanyIds: [],
      repairPlaceSharingWorkshopIds: [],
      text: "",
      pageNumber: 1,
      rowsPerPage: 10,
      sortDirection: "DESC",
      sortColumn: "InvoiceStagePassDate",
    };
  }

  static initSearchRepairsForInvoicingCriteria(): SearchRepairsCriteria {
    const crtieria =
      SearchRepairsCriteriaFormBuilder.initSearchRepairsCriteria();
    crtieria.repairStatusIds = [RepairStatus.Closed];
    crtieria.paidState = TripleStateBoolean.False;
    crtieria.rowsPerPage = 25;

    return crtieria;
  }

  static initSearchRepairsCriteriaForWorkshop(): SearchRepairsCriteria {
    const minDate = new Date();

    const criteria =
      SearchRepairsCriteriaFormBuilder.initSearchRepairsCriteria();
    criteria.minForecastedDate = minDate;
    criteria.rowsPerPage = 25;

    return criteria;
  }

  static initSearchRepairsCriteriaForDealer(): SearchRepairsCriteria {
    const minDate = new Date();
    minDate.setDate(minDate.getDate() - 30);

    const maxDate = new Date();

    const criteria =
      SearchRepairsCriteriaFormBuilder.initSearchRepairsCriteria();
    criteria.startOfCloseDate = minDate;
    criteria.endOfCloseDate = maxDate;
    criteria.repairStatusIds = [];
    return criteria;
  }
}
